import React, { useEffect, useState } from "react";
import axios from "axios";

function DetalleOmAgrupada({ idOm }) {
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!idOm) return;

    const obtenerInformacion = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerGestionGrupo?padreId=${idOm}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          },
        );

        setData(response.data);
      } catch (error) {
        console.error("Error obteniendo información:", error);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    obtenerInformacion();
  }, [idOm]);

  const fecha = (valor) => {
    if (!valor) return "No registrado";

    const f = new Date(valor);

    return isNaN(f.getTime())
      ? valor
      : f.toLocaleString("es-CO", {
          dateStyle: "short",
          timeStyle: "short",
        });
  };

  const estado = (valor) => {
    if (!valor) return "Sin estado";

    const e = valor.toLowerCase();

    if (e.includes("final") || e.includes("solucion"))
      return "badge badge-success";

    if (e.includes("parcial") || e.includes("proceso"))
      return "badge badge-warning";

    if (e.includes("reiter") || e.includes("devuelta"))
      return "badge badge-danger";

    return "badge badge-secondary";
  };

  const Campo = ({ titulo, valor }) => (
    <div className="col-md-6 mb-3">
      <small className="text-muted font-weight-bold">{titulo}</small>
      <div className="mt-1">
        {valor !== null && valor !== undefined && valor !== ""
          ? valor
          : "No registrado"}
      </div>
    </div>
  );

  const Gestion = ({ gestion }) => (
    <div className="border rounded p-3 mb-3">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <strong>Gestión #{gestion.id}</strong>

        <span className={estado(gestion.estado)}>
          {gestion.estado || "Sin estado"}
        </span>
      </div>

      <div className="row">
        <Campo titulo="Acción de mejora" valor={gestion.accionMejora} />

        <Campo
          titulo="Elemento de verificación"
          valor={gestion.elementoVerificacion}
        />

        <Campo titulo="Observación" valor={gestion.observacion} />

        <Campo titulo="Comentarios" valor={gestion.comentarios} />

        <Campo
          titulo="Fecha de creación"
          valor={fecha(gestion.fechaCreacion)}
        />

        <Campo
          titulo="Fecha de modificación"
          valor={fecha(gestion.fechaModificacion)}
        />

        <Campo titulo="Usuario" valor={gestion.usuarioId} />
      </div>
    </div>
  );

  const cantidadGestiones = (hijas = []) =>
    hijas.reduce((total, hija) => total + (hija.gestiones?.length || 0), 0);

  return (
    <>
      <button
        type="button"
        className={`btn ${data ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => setShow(true)}
        disabled={loading || !data}
      >
        <i
          className={`fas ${
            loading ? "fa-spinner fa-spin" : data ? "fa-eye" : "fa-eye-slash"
          } mr-1`}
        />

        {loading ? "Cargando..." : data ? "Ver detalle" : "Sin información"}
      </button>

      {show && data && (
        <>
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,.55)",
            }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                {/* HEADER */}
                <div className="modal-header">
                  <div>
                    <h5
                      className="modal-title font-weight-bold"
                      style={{ color: "#0085CA" }}
                    >
                      <i className="fas fa-layer-group mr-2" />
                      Detalle de oportunidad agrupada
                    </h5>

                    <small className="text-muted">
                      Principal #{data.padreId}
                    </small>
                  </div>

                  <button className="close" onClick={() => setShow(false)}>
                    &times;
                  </button>
                </div>

                {/* BODY */}
                <div className="modal-body">
                  {/* INFORMACIÓN PADRE */}
                  <div className="alert alert-light border">
                    <div className="row">
                      <Campo
                        titulo="ID oportunidad Principal"
                        valor={data.padreId}
                      />

                      <Campo
                        titulo="Descripción"
                        valor={data.descripcionPadre}
                      />

                      <Campo
                        titulo="Evaluadores"
                        valor={data.evaluadores?.length || 0}
                      />

                      <Campo
                        titulo="Gestiones grupales"
                        valor={data.gestionesMaestras?.length || 0}
                      />

                      <Campo
                        titulo="Oportunidades "
                        valor={data.hijas?.length || 0}
                      />

                      <Campo
                        titulo="Total gestiones "
                        valor={cantidadGestiones(data.hijas)}
                      />
                    </div>
                  </div>

                  {/* EVALUADORES */}
                  {data.evaluadores?.length > 0 && (
                    <details className="mb-3" open>
                      <summary className="font-weight-bold text-primary">
                        <i className="fas fa-user-check mr-2" />
                        Evaluadores ({data.evaluadores.length})
                      </summary>

                      <div className="mt-3">
                        {data.evaluadores.map((evaluador) => (
                          <div
                            className="border rounded p-3 mb-2"
                            key={evaluador.id}
                          >
                            <div className="row">
                              <Campo titulo="ID" valor={evaluador.id} />

                              <Campo
                                titulo="Evaluador"
                                valor={evaluador.evaluadorId}
                              />

                              <Campo
                                titulo="Solicitud"
                                valor={evaluador.solicitudId}
                              />

                              <Campo
                                titulo="Actualización"
                                valor={fecha(evaluador.fechaActualizacion)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </details>
                  )}

                  {/* GESTIONES GRUPALES */}
                  <details className="mb-3" open>
                    <summary className="font-weight-bold text-primary">
                      <i className="fas fa-tasks mr-2" />
                      Gestiones grupales ({data.gestionesMaestras?.length || 0})
                    </summary>

                    <div className="mt-3">
                      {data.gestionesMaestras?.length ? (
                        data.gestionesMaestras.map((gestion) => (
                          <Gestion key={gestion.id} gestion={gestion} />
                        ))
                      ) : (
                        <div className="text-muted">
                          No existen gestiones grupales.
                        </div>
                      )}
                    </div>
                  </details>

                  {/* HIJAS */}
                  <details className="mb-3" open>
                    <summary className="font-weight-bold text-primary">
                      <i className="fas fa-sitemap mr-2" />
                      Oportunidades del grupo ({data.hijas?.length || 0})
                    </summary>

                    <div className="mt-3">
                      {data.hijas?.length ? (
                        data.hijas.map((hija, index) => (
                          <details
                            key={hija.hijaId}
                            className="border rounded mb-3"
                            open
                          >
                            <summary className="p-3 bg-light">
                              <strong>
                                {index + 1}. OM #{hija.hijaId}
                              </strong>

                              <span
                                className={`${estado(
                                  hija.estadoOportunidad,
                                )} ml-2`}
                              >
                                {hija.estadoOportunidad || "Sin estado"}
                              </span>

                              <span className="badge badge-info ml-2">
                                {hija.tieneGestionPropia
                                  ? "Gestión propia"
                                  : "Gestión grupal"}
                              </span>
                            </summary>

                            <div className="p-3">
                              <div className="row">
                                <Campo titulo="ID " valor={hija.hijaId} />

                                <Campo
                                  titulo="Consecutivo"
                                  valor={hija.nConsecutivo}
                                />

                                <Campo
                                  titulo="Estado"
                                  valor={hija.estadoOportunidad}
                                />

                                <Campo
                                  titulo="Tipo de gestión"
                                  valor={
                                    hija.tieneGestionPropia
                                      ? "Propia"
                                      : "Grupal"
                                  }
                                />

                                <Campo
                                  titulo="Descripción"
                                  valor={hija.descripcionHija}
                                />
                              </div>

                              <hr />

                              <h6 className="font-weight-bold text-primary">
                                Gestiones ({hija.gestiones?.length || 0})
                              </h6>

                              {hija.gestiones?.length ? (
                                hija.gestiones.map((gestion) => (
                                  <Gestion key={gestion.id} gestion={gestion} />
                                ))
                              ) : (
                                <div className="text-muted">
                                  Esta oportunidad no tiene gestiones.
                                </div>
                              )}
                            </div>
                          </details>
                        ))
                      ) : (
                        <div className="text-muted">
                          No existen oportunidades hijas.
                        </div>
                      )}
                    </div>
                  </details>
                </div>

                {/* FOOTER */}
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShow(false)}
                  >
                    <i className="fas fa-times mr-1" />
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal-backdrop fade show"
            onClick={() => setShow(false)}
          />
        </>
      )}
    </>
  );
}

export default DetalleOmAgrupada;
